var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-scroll-y-transition",
    {
      attrs: {
        "hide-on-leave": "",
        "leave-absolute": ""
      }
    },
    [
      _vm.step === _vm.surveyStepperStep
        ? _c(
            "div",
            {
              key: "step---".concat(_vm.step),
              staticClass: "app-survey-step__content"
            },
            [_vm._t("default")],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }